import { useAuthActions } from "@convex-dev/auth/react";
import { useConvexAuth } from "convex/react";
import { Navigate, Outlet } from "react-router";
import { useCurrentUser } from "../lib/useCurrentUser";
import { ClientSidebar } from "./ClientSidebar";
import { Button, Footer } from "@repo/ui";

function EcranNonProvisionne() {
  const { signOut } = useAuthActions();
  // Déconnexion requise : sinon /login redirige vers "/" → même écran.
  // Après signOut, isAuthenticated passe à false → le guard renvoie vers /login.
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="text-center max-w-md p-8">
        <h2 className="text-xl font-semibold mb-2">Compte non provisionné</h2>
        <p className="text-muted-foreground mb-6">
          Votre compte n'est pas encore associé à une organisation. Contactez votre administrateur.
        </p>
        <Button onClick={() => void signOut()}>Retour à la connexion</Button>
      </div>
    </div>
  );
}

export function AdminAuthGuard() {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const currentUser = useCurrentUser();

  if (isLoading || (isAuthenticated && currentUser === undefined)) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Compte non provisionné : pas de profil, OU pas d'org (mono-org obligatoire).
  // Un super-admin sans org est traité comme un user normal → non provisionné.
  if (!currentUser || !currentUser.organisationId) {
    return <EcranNonProvisionne />;
  }

  return (
    // `items-start` : la sidebar est `sticky top-0 h-screen` en desktop, elle
    // ne doit pas être étirée à la hauteur du contenu scrollé.
    //
    // AUCUN `overflow-*` ici : il ferait de cette div le conteneur de
    // défilement de référence du `sticky` de la sidebar. Comme c'est la PAGE
    // qui scrolle et non cette div, le `sticky` ne s'accrocherait à rien et la
    // sidebar défilerait avec le contenu. Le clamp horizontal vit sur la
    // colonne de contenu, seule surface susceptible de déborder.
    <div className="flex min-h-screen w-full items-start">
      <ClientSidebar />
      <div className="flex min-h-screen min-w-0 flex-1 flex-col overflow-x-hidden pt-14 md:pt-0">
        <main className="w-full min-w-0 flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
